const PromotionSection = () => {
  return (
    <section className="py-12 sm:py-16 bg-gradient-to-r from-red-500 via-pink-500 to-orange-500 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0">
        <div className="absolute top-10 left-10 w-20 h-20 bg-white/10 rounded-full animate-pulse"></div>
        <div className="absolute top-32 right-20 w-16 h-16 bg-white/10 rounded-full animate-pulse delay-1000"></div>
        <div className="absolute bottom-20 left-32 w-24 h-24 bg-white/10 rounded-full animate-pulse delay-500"></div>
        <div className="absolute bottom-32 right-10 w-12 h-12 bg-white/10 rounded-full animate-pulse delay-700"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-8 sm:mb-12">
          <div className="inline-flex items-center bg-white/20 backdrop-blur-sm rounded-full px-4 sm:px-6 py-2 mb-4 sm:mb-6">
            <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center mr-2 text-white">
              <i className="ri-fire-line text-lg sm:text-xl"></i>
            </div>
            <span className="text-white font-semibold text-sm sm:text-base">威斯理美語CMAP營隊</span>
          </div>
          
          <h3 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4 px-4">
            寒假營隊14天原價11200
          </h3>
          <h4 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-yellow-300 mb-4 sm:mb-6 px-4">
            限時優惠專案
          </h4>
          <p className="text-base sm:text-lg md:text-xl text-white/90 leading-relaxed max-w-3xl mx-auto px-4">
            現在報名享有超值優惠，讓您的孩子以最優惠的價格體驗最棒的營隊活動！
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {/* 優惠專案A */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 sm:p-8 shadow-2xl">
            <div className="text-center mb-4 sm:mb-6">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-gradient-to-r from-blue-500 to-blue-600 rounded-full mx-auto mb-3 sm:mb-4">
                <i className="ri-time-line text-white text-xl sm:text-2xl"></i>
              </div>
              <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">1.優惠專案A</h4>
              <p className="text-sm sm:text-base text-gray-600">提早報名享受超值優惠</p>
            </div>

            <div className="space-y-3 sm:space-y-4">
              <div className="bg-blue-50 rounded-xl p-3 sm:p-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-semibold text-blue-700 text-sm sm:text-base">(A)11月報名優惠</span>
                  <span className="text-xl sm:text-2xl font-bold text-blue-600">1500</span>
                </div>
                <p className="text-xs sm:text-sm text-blue-600">11月報名可享1500元優惠</p>
              </div>

              <div className="bg-green-50 rounded-xl p-3 sm:p-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-semibold text-green-700 text-sm sm:text-base">(B)12月報名優惠</span>
                  <span className="text-xl sm:text-2xl font-bold text-green-600">1000</span>
                </div>
                <p className="text-xs sm:text-sm text-green-600">12月報名可享1000元優惠</p>
              </div>

              <div className="bg-purple-50 rounded-xl p-3 sm:p-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-semibold text-purple-700 text-sm sm:text-base">(C)1月報名優惠</span>
                  <span className="text-xl sm:text-2xl font-bold text-purple-600">500</span>
                </div>
                <p className="text-xs sm:text-sm text-purple-600">1月報名可享500元優惠</p>
              </div>
            </div>
          </div>

          {/* 兄弟姊妹優惠專案B */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 sm:p-8 shadow-2xl">
            <div className="text-center mb-4 sm:mb-6">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-gradient-to-r from-orange-500 to-red-500 rounded-full mx-auto mb-3 sm:mb-4">
                <i className="ri-group-line text-white text-xl sm:text-2xl"></i>
              </div>
              <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">2.兄弟姊妹優惠專案B</h4>
              <p className="text-sm sm:text-base text-gray-600">兄弟姊妹一起報名更優惠</p>
            </div>

            <div className="space-y-3 sm:space-y-4">
              <div className="bg-orange-50 rounded-xl p-3 sm:p-4">
                <div className="mb-2">
                  <span className="font-semibold text-orange-700 text-sm sm:text-base">(A)半價優惠</span>
                </div>
                <p className="text-xs sm:text-sm text-orange-600 leading-relaxed">兄弟姊妹團報第一個半價（第一名原價，第二名原價半價），平均每人8400元</p>
                <p className="text-xs text-orange-500 mt-1">（平均一天600）</p>
              </div>
            </div>
          </div>

          {/* 團報優惠專案C */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 sm:p-8 shadow-2xl md:col-span-2 lg:col-span-1">
            <div className="text-center mb-4 sm:mb-6">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-gradient-to-r from-emerald-500 to-green-500 rounded-full mx-auto mb-3 sm:mb-4">
                <i className="ri-team-line text-white text-xl sm:text-2xl"></i>
              </div>
              <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">3.團報優惠專案C</h4>
              <p className="text-sm sm:text-base text-gray-600">多人團報享更多優惠</p>
            </div>

            <div className="space-y-3 sm:space-y-4">
              <div className="bg-emerald-50 rounded-xl p-3 sm:p-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-semibold text-emerald-700 text-sm sm:text-base">(A)兩人同行</span>
                  <span className="text-base sm:text-lg font-bold text-emerald-600">9000</span>
                </div>
                <p className="text-xs sm:text-sm text-emerald-600">每人只要9000（平均一天640）</p>
              </div>

              <div className="bg-teal-50 rounded-xl p-3 sm:p-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-semibold text-teal-700 text-sm sm:text-base">(B)三人同行</span>
                  <span className="text-base sm:text-lg font-bold text-teal-600">8000</span>
                </div>
                <p className="text-xs sm:text-sm text-teal-600">每人只要8000（平均一天570）</p>
              </div>

              <div className="bg-cyan-50 rounded-xl p-3 sm:p-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-semibold text-cyan-700 text-sm sm:text-base">(C)四人同行</span>
                  <span className="text-base sm:text-lg font-bold text-cyan-600">7500</span>
                </div>
                <p className="text-xs sm:text-sm text-cyan-600">每人只要7500（平均一天535）</p>
              </div>
            </div>
          </div>
        </div>

        {/* 重要提醒 */}
        <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 sm:p-8 text-center shadow-2xl">
          <div className="mb-4 sm:mb-6">
            <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">
              <span className="text-red-600">重要提醒</span>
            </h4>
            <div className="text-left max-w-2xl mx-auto space-y-2">
              <p className="text-sm sm:text-base text-gray-700">
                <i className="ri-information-line mr-2 text-red-500"></i>
                <strong className="text-red-600">上面優惠活動只能擇一</strong>
              </p>
              <p className="text-sm sm:text-base text-gray-700">
                <i className="ri-map-pin-line mr-2 text-blue-500"></i>
                地址：北屯路388號2樓
              </p>
              <p className="text-sm sm:text-base text-gray-700">
                <i className="ri-phone-line mr-2 text-green-500"></i>
                電話：22436255或0982621889
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center">
            <button 
              onClick={() => {
                const registerSection = document.getElementById('register');
                if (registerSection) {
                  registerSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="w-full sm:w-auto bg-gradient-to-r from-red-600 to-pink-600 text-white px-8 sm:px-10 py-3 sm:py-4 rounded-full text-base sm:text-lg font-bold hover:from-red-700 hover:to-pink-700 transition-all duration-300 transform hover:scale-105 shadow-lg cursor-pointer whitespace-nowrap"
            >
              <div className="flex items-center justify-center space-x-2">
                <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
                  <i className="ri-rocket-line"></i>
                </div>
                <span>立即搶購優惠名額</span>
              </div>
            </button>

            <button 
              onClick={() => {
                const contactSection = document.getElementById('contact');
                if (contactSection) {
                  contactSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="w-full sm:w-auto border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-white hover:text-gray-900 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <div className="flex items-center justify-center space-x-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line"></i>
                </div>
                <span>電話諮詢</span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromotionSection;